var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="sadasd"> <div id="editor_iframeContentBuilder_div"> <iframe id="editor_iframeContentBuilder" src="" style="height:800px; width:100%"></iframe> </div> </div>';
}
return __p;
};
